import { createSelector } from 'reselect'
import formatLesson from 'redux/selectors/helpers/lesson_formatter'
import { formatLibraryType } from 'helpers/libraryTypeFormatter'
import shouldHideStoreSelector from 'redux/selectors/user/user_store_access_selector'
import activitiesCounter from 'helpers/interactive_video/activities_counter'
import mediaSlide from 'redux/selectors/media_slides/find_media_slide'
import lessonTypes from 'helpers/enums/lessonTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import tooltipTypes from 'helpers/enums/tooltipTypes'
import sessionTypes from 'helpers/enums/sessionTypes'
import getAssetById from 'redux/selectors/assets/asset_selector'
import mediaTypes from 'helpers/enums/mediaTypes'
import lessonStatusTypes from 'helpers/enums/lessonStatusTypes'

const getMyLibraryPreview = state => state.myLibraryPreview
const getLessons = state => state.lessons
const getPreview = state => state.preview
const getLti = state => state.lti

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.VIDEO_LESSON_SHOW_TEACH_BUTTON,
	featureFlagsTypes.INTERACTIVE_VIDEO_PREVIEW_CREDITS_TAB,
	featureFlagsTypes.INTERACTIVE_VIDEO_PREVIEW_STANDARDS_TAB,
])

const myLibraryPreviewViewSelector = createSelector(
	[
		getMyLibraryPreview,
		getLessons,
		getLti,
		shouldHideStoreSelector,
		mediaSlide,
		getPreview,
		featureFlagsSelector,
		getAssetById,
	],
	(myLibraryPreview, lessons, lti, shouldHideStore, mediaSlide, preview, featureFlags, getAsset) => {
		let promoted = myLibraryPreview.promoted.map(promotedItem => ({
			...promotedItem,
			entities: promotedItem.entities.map(entityUID => lessons[entityUID]),
		}))
		const libraryType = formatLibraryType(lti)
		let lessonData, presentationUid
		let sessionTypeLaunched = sessionTypes.UNSET
		const lesson = lessons[myLibraryPreview.entityUID]
		if (lesson) {
			const isTeachButtonActive = featureFlags[featureFlagsTypes.VIDEO_LESSON_SHOW_TEACH_BUTTON]
			const canEditLesson = lesson.data.state === lessonStatusTypes.PUBLISHED
			lessonData = formatLesson(
				lesson,
				libraryType,
				false,
				tooltipTypes.NONE,
				false,
				false,
				isTeachButtonActive,
				canEditLesson,
			)
			if (lessonData && lessonData.data) {
				presentationUid = lessonData.data.presentation_uid
				if (lessonData.data.type === lessonTypes.VIDEO) {
					const media = mediaSlide(presentationUid)
					const asset = getAsset(media.posterUid, mediaTypes.IMAGE)
					sessionTypeLaunched = preview.sessionLaunchedType
					promoted = promoted.length > 0 ? promoted[0].entities : []
					lessonData.data = {
						...lessonData.data,
						totalActivities: activitiesCounter(media),
						duration: media.duration,
						posterUrl: asset ? asset.sizes.medium.path : null,
						handouts: media.handouts,
						isExtraInformationLoaded: preview.isExtraInformationLoaded,
						credits: media.credits,
						shouldShowCreditsTab: featureFlags[featureFlagsTypes.INTERACTIVE_VIDEO_PREVIEW_CREDITS_TAB],
						shouldShowStandardsTab: featureFlags[featureFlagsTypes.INTERACTIVE_VIDEO_PREVIEW_STANDARDS_TAB],
					}
				}
			}
		}

		return {
			lessonData,
			promoted,
			shouldShowRelatedContent: !shouldHideStore,
			presentationUid,
			sessionTypeLaunched,
		}
	}
)

export default myLibraryPreviewViewSelector
